import { Component } from '@angular/core';

@Component({
  selector: 'app-kitchen-printing',
  templateUrl: './kitchen-printing.component.html',
  styleUrls: ['./kitchen-printing.component.css']
})
export class KitchenPrintingComponent {

}
